import React, {FC, useState, useEffect} from "react";
import moment from "moment";
import {Button} from "antd";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import FormItem from "antd/es/form/FormItem";
import classNames from "classnames";
import LayoutForm from "../../../../../../../../views/LayoutForm/LayoutForm";
import MoneyInput from "../../../../../../../../views/MoneyInput/MoneyInput";
import {EditPaymentProps} from "./types";
import css from "../RenderPaymentList.less";
import DateInput from "../../../../../../../../views/DateInput/DateInput";

const EditPaymentView: FC<EditPaymentProps> = ({payment, rowIndex, onSave, onCancel, loading}) => {
    // Wichtig: Sofort mit konkreten Werten initialisieren
    const [paymentAmount, setPaymentAmount] = useState<number>(payment.paymentAmount || 0);
    const [paymentDue, setPaymentDue] = useState<Date>(payment.paymentDue);

    // Mit useEffect auf Änderungen des payment-Props reagieren
    useEffect(() => {
        console.log("Payment geändert:", payment);
        setPaymentAmount(payment.paymentAmount || 0);
        setPaymentDue(payment.paymentDue);
    }, [payment]);

    // Für das Datum muss ein gültiges moment-Objekt verwendet werden
    const momentDate = moment(paymentDue);

    // Log für Debugging
    console.log("Render EditPayment mit paymentAmount:", paymentAmount, typeof paymentAmount);

    const handleSave = () => {
        const newPayment = {
            ...payment,
            paymentAmount,
            paymentDue,
        };

        onSave(newPayment, rowIndex);
    };

    return (
        <div className={classNames(css.editPaymentContainer)} key={payment.id}>
            <div className={css.monthOfDueContainer}>
                <div className={css.paymentNumber}>
                    {rowIndex + 1}
                    {"."}
                </div>
                <div className={css.monthOfDue}>{moment(payment.paymentDue).format("MMM YY")}</div>
            </div>
            <LayoutForm>
                <FormItem label="Zahlbar bis" className={css.formItem}>
                    <DateInput
                        // Stelle sicher, dass das Datum korrekt formatiert ist
                        value={momentDate.isValid() ? momentDate : undefined}
                        allowClear={false}
                        onChange={(value) => setPaymentDue(value?.toDate() ?? new Date())}
                        style={{width: "100%"}}
                        displayFormat="DD.MM.YYYY"
                    />
                </FormItem>
                <FormItem name="paymentAmount" label="Betrag" className={css.formItem}>
                    {/* Füge Debug-Informationen im DOM hinzu */}
                    <div style={{display: "none"}}>
                        {"Debug: amount="}
                        {paymentAmount}
                        {", type="}
                        {typeof paymentAmount}
                    </div>
                    <MoneyInput
                        key={`money-input-${payment.id}-${paymentAmount}`}
                        defaultValue={paymentAmount}
                        value={paymentAmount}
                        onChange={(value) =>
                            setPaymentAmount(value !== undefined && value !== null ? Number(value) : 0)
                        }
                        autoFocus
                    />
                </FormItem>
                <div className={css.buttonsContainer}>
                    <Button type="default" icon={<CloseOutlined />} onClick={() => onCancel(payment)} />
                    <Button type="primary" icon={<CheckOutlined />} onClick={handleSave} />
                </div>
            </LayoutForm>
        </div>
    );
};

export default EditPaymentView;
